<template>
  <div class="main">
    <!-- <br /> -->
    <v-row dense>
      <v-col cols="12" sm="2" md="2" align="right">
        <img
          v-if="person_details.rep_header.school_logo"
          :src="person_details.rep_header.school_logo"
          style="width: 150px"
          alt="logo"
        />
      </v-col>
      <v-col cols="12" sm="8" md="8" align="center">
        <h2>TMV'S</h2>
        <h1
          style="text-transform: uppercase"
          v-if="person_details.rep_header.school_name"
        >
          {{ person_details.rep_header.school_name }}
        </h1>
        <h4 class="mdi mdi-map-marker">
          {{ person_details.rep_header.address }} -
          {{ person_details.rep_header.pin }} <br />
          (Affiliated to CBSE Delhi, Affiliation No.
          {{ person_details.rep_header.cbsc_no }}, School No.
          {{ person_details.rep_header.school_no }}) <br />
          Tel.: {{ person_details.rep_header.phone }}
        </h4>
      </v-col>
      <v-col cols="12" sm="2" md="2">
        <v-img
          width="150"
          :src="
            awspath +
            person_details.profile_image_path +
            person_details.profile_image_name
          "
          aspect-ratio="1"
          class="lighten-2"
          style="border: 1px solid black"
        ></v-img>
      </v-col>
    </v-row>
    <div align="center">
      <h2 style="text-decoration: underline">ADMISSION FORM</h2>
    </div>
    <!-- <br /> -->
    <div style="padding: 20px">
      <v-row>
        <v-col cols="12" sm="6" md="6" align="left">
          Form No. {{ person_details.admission_form_no }}
        </v-col>
        <v-col cols="12" sm="6" md="6" align="right">
          Date of Form Taken :
        </v-col>
      </v-row>
      <p>
        To, <br />
        The Principal, <br />
        I wish to admit my ward in your school. I furnish the necessary details
        as below. <br />
        Particulars regarding pupil:
      </p>
      <!-- <br /> -->
      <b style="font-size: 22px">Details of Ward : *</b><br />
      <v-row dense>
        <!-- <div class="col-3"> -->
        <v-col cols="12" sm="3" md="3"
          ><span><b>1. Full Name of the student : </b></span></v-col
        >
        <!-- <span class="underline" style="width: 759px;" >{{ person_details.lastname.field_value }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ person_details.firstname.field_value }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ person_details.middlename.field_value }}</span> -->
        <!-- </div> -->
        <!-- <v-row dense> -->
        <v-col
          cols="12"
          sm="2"
          md="2"
          style="margin-left: -40px"
          v-if="person_details.lastname"
          ><span class="underline" style="width: 159px">{{
            person_details.lastname.field_value
          }}</span></v-col
        >
        <v-col cols="12" sm="2" md="2" v-if="person_details.firstname"
          ><span class="underline" style="width: 159px">{{
            person_details.firstname.field_value
          }}</span></v-col
        >
        <v-col cols="12" sm="2" md="2" v-if="person_details.middlename"
          ><span class="underline" style="width: 440px">{{
            person_details.middlename.field_value
          }}</span></v-col
        >
        <!-- </v-row> -->
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="3" md="3"></v-col>
        <v-col
          cols="12"
          sm="2"
          md="2"
          style="margin-left: -40px"
          class="pt-0"
          align="left"
          >(Surname)</v-col
        >
        <v-col cols="12" sm="2" md="2" class="pt-0" align="left">(Name)</v-col>
        <v-col cols="12" sm="3" md="3" class="pt-0" align="left"
          >(Middle name)</v-col
        >
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>2. Date of Birth (DD/MM/YYYY) : </b></span>
          <span
            class="underline"
            style="width: 229px"
            v-if="person_details.date_of_birth"
          >
            {{ person_details.date_of_birth.field_value }}</span
          >
          <span><b>(In Words) : </b></span>
          <span
            class="underline"
            style="width: 412px"
            v-if="person_details.date_of_birth_in_words"
            >{{ person_details.date_of_birth_in_words.field_value }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>3. Place of Birth: Town/Village : </b></span>
          <span
            class="underline"
            style="width: 379px"
            v-if="person_details.birth_place"
            >{{ person_details.birth_place.field_value }}</span
          >
          <span><b>Taluka : </b></span>
          <span
            class="underline"
            style="width: 295px"
            v-if="person_details.local_address"
            >{{ person_details.local_address.ltaluka }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>4. District : </b></span>
          <span
            class="underline"
            style="width: 269px"
            v-if="person_details.local_address"
            >{{ person_details.local_address.lcity }}</span
          >
          <span><b>State : </b></span>
          <span
            class="underline"
            style="width: 257px"
            v-if="person_details.local_address"
            >{{ person_details.local_address.lstate }}</span
          >
          <span><b>Country : </b></span>
          <span
            class="underline"
            style="width: 237px"
            v-if="person_details.local_address"
            >{{ person_details.local_address.lcountry }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>5. Ward Adhar Card No.: </b></span>
          <span
            class="underline"
            style="width: 399px"
            v-if="person_details.aadhar_no"
            >{{ person_details.aadhar_no.field_value }}</span
          >
          <span><b>Gender : </b></span>
          <span
            class="underline"
            style="width: 320px"
            v-if="person_details.gender"
            >{{ person_details.gender.field_value }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>6. Mother Tounge : </b></span>
          <span
            class="underline"
            style="width: 209px"
            v-if="person_details.mothertoungue"
            >{{ person_details.mothertoungue.field_value }}</span
          >
          <span><b>Nationality : </b></span>
          <span
            class="underline"
            style="width: 227px"
            v-if="person_details.nationality"
            >{{ person_details.nationality.field_value }}</span
          >
          <span><b>Religion : </b></span>
          <span
            class="underline"
            style="width: 227px"
            v-if="person_details.religion"
            >{{ person_details.religion.field_value }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>7. Cast : </b></span>
          <span
            class="underline"
            style="width: 209px"
            v-if="person_details.cast"
            >{{ person_details.cast.field_value }}</span
          >
          <span><b>Category : </b></span>
          <span
            class="underline"
            style="width: 257px"
            v-if="person_details.category"
            >{{ person_details.category.field_value }}</span
          >
          <span><b>(Open/SC/NT/OBC/Others) </b></span>
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>8. Class in which to be Admitted : </b></span>
          <span
            class="underline"
            style="width: 279px"
            v-if="person_details.standard"
            >{{ person_details.standard.field_value }}</span
          >
          <span><b>Ward Blood Group : </b></span>
          <span
            class="underline"
            style="width: 297px"
            v-if="person_details.bloodgroup"
            >{{ person_details.bloodgroup.field_value }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>9. Previous School Name: </b></span>
          <span
            class="underline"
            style="width: 479px"
            v-if="person_details.previous_school_name"
            >{{ person_details.previous_school_name.field_value }}</span
          >
          <span><b>Std. : </b></span>
          <span
            class="underline"
            style="width: 247px"
            v-if="person_details.previousschoolpassingstandard"
            >{{
              person_details.previousschoolpassingstandard.field_value
            }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>10. Permanent Residential Address: </b></span>
          <span
            class="underline"
            style="width: 700px"
            v-if="person_details.permanent_address"
            >{{ person_details.permanent_address.paddress }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span class="underline" style="width: 960px"></span>
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>11. Current Residential Address: </b></span>
          <span
            class="underline"
            style="width: 720px"
            v-if="person_details.local_address"
            >{{ person_details.local_address.laddress }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span class="underline" style="width: 960px"></span>
        </div>
      </v-row>
      <br />
      <b style="font-size: 22px">Medical Information : *</b><br />
      <v-row dense>
        <div class="col-12">
          <span><b>Does the student have any medical conditions? </b></span>
          <span
            class="underline"
            style="width: 79px"
            v-if="person_details.medical_problem"
            >{{ person_details.medical_problem.field_value ? "YES" : "NO" }}
          </span>
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>If yes, please specify: </b></span>
          <span
            class="underline"
            style="width: 799px"
            v-if="person_details.medical_problem"
            >{{ person_details.medical_problem.field_value }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>Emergency Contact Name & Number: </b></span>
          <span
            class="underline"
            style="width: 689px"
            v-if="
              person_details.emergency_contact_name.field_value ||
              person_details.emergency_contact_number.field_value
            "
            >{{ person_details.emergency_contact_name.field_value }} -
            {{ person_details.emergency_contact_number.field_value }}</span
          >
        </div>
      </v-row>
      <br />
      <b style="font-size: 22px">Additional Information : *</b><br />
      <v-row dense>
        <div class="col-12">
          <span><b>Is Cast certificate Available: </b></span>
          <span
            class="underline"
            style="width: 79px"
            v-if="person_details.is_cast_certificate_available"
            >{{
              person_details.is_cast_certificate_available.field_value
            }}</span
          >(Yes/No)
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>Belong to minority Group: </b></span>
          <span
            class="underline"
            style="width: 379px"
            v-if="person_details.minority"
            >{{ person_details.minority.field_value }}</span
          >(Muslim/Christain/Sikh/Buddhist/Parsi/NA)
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>Are you BPL Beneficiary: </b></span>
          <span
            class="underline"
            style="width: 179px"
            v-if="person_details.is_bpl_beneficiary"
            >{{ person_details.is_bpl_beneficiary.field_value }}</span
          >(Yes/No) <b> Do You belong to EWS: </b>
          <span
            class="underline"
            style="width: 179px"
            v-if="person_details.is_EWS"
            >{{ person_details.is_EWS.field_value }}</span
          >(Yes/No)
        </div>
      </v-row>
      <br />
      <b style="font-size: 22px">Parents Information : *</b><br />
      <v-row dense>
        <div class="col-12">
          <span><b>1. Father's Name : </b></span>
          <span
            class="underline"
            style="width: 379px"
            v-if="person_details.relative_father_details"
            >{{
              person_details.relative_father_details.relative_full_name
            }}</span
          >
          <span><b>Occupation : </b></span>
          <span
            class="underline"
            style="width: 257px"
            v-if="person_details.relative_father_details"
            >{{
              person_details.relative_father_details.relative_occupation
            }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>2. Mother's Name: </b></span>
          <span
            class="underline"
            style="width: 379px"
            v-if="person_details.relative_mother_details"
            >{{
              person_details.relative_mother_details.relative_full_name
            }}</span
          >
          <span><b>Occupation : </b></span>
          <span
            class="underline"
            style="width: 257px"
            v-if="person_details.relative_mother_details"
            >{{
              person_details.relative_mother_details.relative_occupation
            }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>3. Mother's Adhar No.: </b></span>
          <span
            class="underline"
            style="width: 209px"
            v-if="person_details.relative_mother_details"
            >{{
              person_details.relative_mother_details.relative_aadharno
            }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>4. Father's Adhar No.: </b></span>
          <span
            class="underline"
            style="width: 209px"
            v-if="person_details.relative_father_details"
            >{{
              person_details.relative_father_details.relative_aadharno
            }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>5. Mother's Contact No. : </b></span>
          <span
            class="underline"
            style="width: 209px"
            v-if="person_details.relative_mother_details"
            >{{
              person_details.relative_mother_details.relative_contact_no
            }}</span
          >
          <span><b>Father's Contact No. : </b></span>
          <span
            class="underline"
            style="width: 257px"
            v-if="person_details.relative_father_details"
            >{{
              person_details.relative_father_details.relative_contact_no
            }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>6. Mother's Email ID : </b></span>
          <span
            class="underline"
            style="width: 235px"
            v-if="person_details.relative_mother_details"
            >{{ person_details.relative_mother_details.relative_email }}</span
          >
          <span><b>Father's Email ID : </b></span>
          <span
            class="underline"
            style="width: 287px"
            v-if="person_details.relative_father_details"
            >{{ person_details.relative_father_details.relative_email }}</span
          >
        </div>
      </v-row>
    </div>
    <div style="padding: 20px" class="pagebreak">
      <b style="font-size: 22px">Guardian's Information : *</b><br />
      <v-row dense>
        <div class="col-12">
          <span><b>1. Guardian's Name in Full : </b></span>
          <span
            class="underline"
            style="width: 579px"
            v-if="person_details.emergency_contact_name"
            >{{ person_details.emergency_contact_name.field_value }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>2. Guardian's Aadhar No.: </b></span>
          <span
            class="underline"
            style="width: 379px"
            v-if="person_details.emergency_aadhar_no"
            >{{ person_details.emergency_aadhar_no.field_value }}</span
          >
          <span><b>Mobile : </b></span>
          <span
            class="underline"
            style="width: 257px"
            v-if="person_details.emergency_contact_number"
            >{{ person_details.emergency_contact_number.field_value }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>3. Guardian's relation with the student : </b></span>
          <span
            class="underline"
            style="width: 209px"
            v-if="person_details.emergency_relation"
            >{{ person_details.emergency_relation.field_value }}</span
          >
          <span><b>Occupation : </b></span>
          <span
            class="underline"
            style="width: 209px"
            v-if="person_details.emergency_occupation"
            >{{ person_details.emergency_occupation.field_value }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>4. Guardian's Permanent Residental Address: </b></span>
          <span
            class="underline"
            style="width: 209px"
            v-if="person_details.emergency_contact_permanent_address"
            >{{
              person_details.emergency_contact_permanent_address.field_value
            }}</span
          >
        </div>
      </v-row>
      <v-row dense>
        <div class="col-12">
          <span><b>5. Guardian's Local Residental Address : </b></span>
          <span
            class="underline"
            style="width: 209px"
            v-if="person_details.emergency_contact_address"
            >{{ person_details.emergency_contact_address.field_value }}</span
          >
        </div>
      </v-row>
      <br />
      <b style="font-size: 22px">Declaration : *</b>
      <p>
        All the above information mentioned in the form and all the documents
        submitted are correct on my knowledge & that I am responsible for any
        incorrect information/documents.
      </p>
      <br /><br />
      <v-row class="d-flex justify-space-around">
        <v-col
          cols="12"
          sm="3"
          md="3"
          style="border-top: 1px solid black"
          align="center"
          >*Signature of Mother's
        </v-col>
        <v-col
          cols="12"
          sm="3"
          md="3"
          style="border-top: 1px solid black"
          align="center"
          >*Signature of Guardian
        </v-col>
        <v-col
          cols="12"
          sm="3"
          md="3"
          style="border-top: 1px solid black"
          align="center"
          >*Signature of Father's
        </v-col>
      </v-row>
      <br />
      <b style="font-size: 22px">Documents to be Submitted: *</b> <br />
      <div>
        1) Original Birth Certificate of the child (only for Grade I and
        onwards).
      </div>
      <div>
        2) Original Leaving Certificate of the previous school (from Grade II
        onwards).
      </div>
      <div>
        3) Proof of residence: Electricity bill, Aadhaar card, passport, or Rent
        Agreement (photocopy).
      </div>
      <div>
        4) Photographs: One passport-sized photograph each of the child and both
        parents.
      </div>
      <div>
        5) Report card: A photocopy of the report card from the child's previous
        school.
      </div>
      <div>6) Caste certificate (if applicable, photocopy).</div>
      <div>7) Aadhaar card: A photocopy of the student's Aadhaar card.</div>
      <div>
        8) PAN card: A photocopy of the PAN card & Aadhaar card of both parents
        or guardian.
      </div>
      <br /><br />
      <b style="font-size: 22px">RULES & REGULATIONS</b>
      <div>
        1) Admission Form should be filled in the parent's or guardian's own
        handwriting.
      </div>
      <div>
        2) Parents should submit the above documents with self-attestation at
        the time of admission.
      </div>
      <div>
        3) Parents should produce the original leaving certificate from the last
        attended school along with the progress card at the time of admission
        (from Std 2nd onwards).
      </div>
      <div>
        4) Submission of the admission form is not a guarantee of admission. The
        right to grant or refuse admission is reserved by the Headmistress.
      </div>
      <div>
        5) Application for withdrawal or cancellation of admission should be
        submitted 15 days in advance.
      </div>
      <div>
        6) No amount will be refunded for any reason if the admission gets
        canceled.
      </div>
      <div>
        7) The leaving certificate can be issued only after clearing all dues up
        to the date of the LC application.
      </div>
      <div>8) The candidate must be present from the first day of school.</div>
      <br /><br />
      <b style="font-size: 22px">OFFICE USE ONLY</b>
      <div>1) Amount to be paid at the time of admission:</div>
      <div>
        2) RTE/Regular:
        <span class="underline" style="width: 209px"></span>
      </div>
      <div>3) Above documents verified by office: Yes/No</div>
      <div>
        4) Admitted/Not Admitted:
        <span class="underline" style="width: 209px"></span>
      </div>
      <div>
        5) Date of Admission:
        <span class="underline" style="width: 209px"></span>
      </div>
      <div>
        6) GR. No: <span class="underline" style="width: 209px"></span>
      </div>
      <br><br><br>
      <v-row class="">
        <v-col
          cols="12"
          sm="5"
          md="5"
          align="left"
          >Clerk Sign : <span class="underline" style="width: 259px"></span>
        </v-col>
        <v-col
          cols="12"
          sm="5"
          md="5"
          align="center"
          >Principal Sign : <span class="underline" style="width: 259px"></span>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: ["person_details"],
  created() {
    this.awspath = localStorage.getItem("awspath");
    this.tenant = localStorage.getItem("EPS-tenant");
    console.log("TMV");
  },
  methods: {
    print() {
      setTimeout(function () {
        window.print();
      }, 100);
    },
  },
};
</script>
  
  <style scoped>
.underline {
  border-bottom: 1px solid;
  display: inline-block;
  /* padding-bottom: 3px; */
  margin-bottom: -5px;
}
.input-line {
  display: inline-block;
  border-bottom: 1px solid black;
  width: 100%;
  height: 20px;
}
.medical_details {
  margin-left: 3px;
}
td,
tr {
  font-weight: bold;
  font-size: 16px;
}
.main {
  padding-left: 1%;
  padding-right: 1%;
  /* background-color: white; */
}
/* #page {
  margin-right: 1%;
  margin-left: 1%;
} */
@media print {
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  .pagebreak {
    page-break-before: always;
    margin-top: 30px;
  }

  header,
  footer,
  nav,
  date {
    display: none !important;
  }
}
.row:after {
  content: "";
  display: table;
  clear: both;
}

/* shiv css  */
.personal_details {
  border: 2px solid black;
  border-radius: 20px;
  padding-bottom: 5px;
}

.sib_table {
  text-align: left;
  border: 1px solid black;

  border-collapse: collapse;
}

.photo {
  margin: 10px;
  margin-top: 15px;
  margin-right: 15px;
  float: right;
}

@page {
  size: A4;
  margin-top: none;
  padding-top: none;
  /* size: 15in 15.5in; */
  size: 11.5in 16.5in;
}
@page :first {
  margin-top: 40px;
}

th:first-of-type {
  border-top-left-radius: 20px;
}

th:last-of-type {
  border-top-right-radius: 20px;
}

tr:last-of-type td:first-of-type {
  border-bottom-left-radius: 20px;
}

tr:last-of-type td:last-of-type {
  border-bottom-right-radius: 20px;
}

.declaration_details {
  font-size: larger;
}

.parent_details td,
tr,
th {
  font-size: 16px !important;
}

/* shiv css end */
</style>
  